<div style="height: 80vh;" class="modal-body">
    <iframe *ngIf="token" style="width: 100%;height: 100%;" #frame [src]="'https://payexpresse.com/payment/checkout/'+token | safe"></iframe>
</div>
